import React from "react";

const ManagedDentalGuard = () => {
    return (
            <>
        <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px', maxWidhth: '800px', margin: '0 auto' }}>
            <h2 style={{ color: '#8B5E3C' }}>Managed DentalGuard</h2>
            <p>
                For information regarding the processing of
                the participating provider's compensation or payment please contact:</p>

            <div>
                <p><b>Managed DentalGuard</b></p>
                <p>P.O. Box 981571<br />
                    El Paso, TX 79998-1571<br />
                    <b>Phone:</b>(888) 618-2016</p>
            </div>
            {/*<footer style ={{marginTop:'20px',fontSize:'12px',color:'#666'}}>*/}
            {/*    <p>© 2025, Managed DentalGuard, Inc., 5005 Rockside Road,*/}
            {/*         Suite 430, Independence, OH 44131, U.S.A.</p>*/}
            {/*    <p>We are committed to protecting your privacy. Read our */}
            {/*        <a href="https://www.guardianlife.com/privacy-policy" target="_blank"*/}
            {/*         rel="noopener noreferrer"> privacy policies</a> for more information.</p>*/}
            {/*</footer>*/}
        </div>
        </>
    )
}

export default ManagedDentalGuard
